import { render } from "./AddItemFromCsvFile.vue?vue&type=template&id=5310cc82"
import script from "./AddItemFromCsvFile.vue?vue&type=script&lang=js"
export * from "./AddItemFromCsvFile.vue?vue&type=script&lang=js"

import "./AddItemFromCsvFile.vue?vue&type=style&index=0&id=5310cc82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__